import type { CompetitionType } from "app/types/competitionType";
import cx from "classnames";
import { Component } from "react";
//
type Props = {
  comp: CompetitionType;
  toggleLeagueSelected: (...args: Array<any>) => any;
  selected: boolean;
};

class ListItem extends Component<Props> {
  render() {
    const { comp, selected, toggleLeagueSelected } = this.props;
    return (
      <li
        className={cx("select-competitions__list-item", {
          "select-competitions__list-item__not-selected": !selected,
        })}
        onClick={() => toggleLeagueSelected(comp.navigationNodeId)}
      >
        <span>{comp.translatedName}</span>
      </li>
    );
  }
}

export default ListItem;
